export const registerTenantColumn = (dashboard) => {
  dashboard.registerColumn({
    type: 'text',
    name: 'customer',
    label: 'monolith.shared.customer',
    options: {
      searchable: true,
      width: '40',
      sortable: false,
    },
  })
}
